import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref} from "vue";
import SogDialog from "@/shared/ui/SogDialog.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {SogDialogButtons} from "@/shared/ui/types/SogDialogButtons";
import TempFileFormComponent from "@/modules/FileUtils/components/TempFileFormComponent.vue";
import apiVehicleRegistration from "@/modules/VehicleRegistration/api";
import notificationService from "@/shared/services/NotificationService";

/**
 * Verknüpft eine Zulassung mit einer Police und speichert optional im selben Schritt einen Anhang.
 * Reihenfolge: erst verknüpfen, dann Anhang speichern – das Backend hängt den Anhang dann
 * automatisch auch an die Police.
 */
interface Props {
  vehicleRegistrationId?: string
  target?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleRegistrationLinkDialog',
  props: {
    vehicleRegistrationId: { default: undefined },
    target: { default: "#app" }
  },
  emits: ["linked"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const _emit = __emit

const _dialog = ref<InstanceType<typeof SogDialog> | null>(null)
const _uploader = ref<InstanceType<typeof TempFileFormComponent> | null>(null)
const _policyNumber = ref<string | undefined>("")
const _tempFileInfo = ref<{ id?: string, fileName?: string, name?: string } | undefined>(undefined)
const _busy = ref(false)

function show() {
  _dialog.value?.show()
}

function reset() {
  _policyNumber.value = ""
  _tempFileInfo.value = undefined
  _uploader.value?.clear()
}

function onCancel() {
  _dialog.value?.hide()
  reset()
}

async function onOk() {
  if (_busy.value) {
    return
  }
  if (!_policyNumber.value) {
    notificationService.error("Policenummer muss angegeben werden")
    return
  }
  if (!props.vehicleRegistrationId) {
    return
  }

  _busy.value = true
  try {
    const linked = await apiVehicleRegistration.insuranceLink(props.vehicleRegistrationId, _policyNumber.value, "", false)
    if (!linked) {
      return
    }

    let t_message = "Zulassung erfolgreich verknüpft"
    const t_file = _tempFileInfo.value
    if (t_file?.id) {
      const saved = await apiVehicleRegistration.addTempFile(t_file.id, props.vehicleRegistrationId, t_file.name, t_file.fileName)
      if (saved) {
        t_message += " und Anhang gespeichert"
      } else {
        notificationService.error("Zulassung wurde verknüpft, der Anhang konnte aber nicht gespeichert werden")
      }
    }
    notificationService.success(t_message)

    _dialog.value?.hide()
    reset()
    _emit("linked")
  } finally {
    _busy.value = false
  }
}

__expose({show})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogDialog, {
    ref_key: "_dialog",
    ref: _dialog,
    target: __props.target,
    width: "500px",
    "dialog-buttons": _unref(SogDialogButtons).OkCancel,
    onClickOk: onOk,
    onClickCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(SogTextBox, {
        modelValue: _policyNumber.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_policyNumber).value = $event)),
        width: "100%",
        placeholder: "Policenummer"
      }, null, 8, ["modelValue"]),
      _createVNode(TempFileFormComponent, {
        ref_key: "_uploader",
        ref: _uploader,
        modelValue: _tempFileInfo.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_tempFileInfo).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["target", "dialog-buttons"]))
}
}

})